const StepLine = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" d="M5.5 17v5.5h4v-18h4v12h4v-9h4V21"></path>
        </svg>
}

export default StepLine